<template>
  <div id="cart">
    <dd-header />
    <div class="wrapper">
      <div class="title cart_title">
        <img :src="getImage('common/icon_cart.svg')" alt="">
        <h1>カート</h1>
      </div>
      <div class="caution_field" v-if="isDisProduct===true">
        <div class="caution_inner">
          <div class="caution_title">
            <img class="caution_icon" :src="getImage('common/icon_caution_y.svg')" alt="">
            <p>重要なお知らせ</p>
          </div>
          <ul class="caution_text">
            <li>カート内に商品仕様が変更、または取り扱いが終了した商品が含まれている為、ご注文へ進めません。</li>
            <li>対象商品をカートから削除し、別の商品をご検討ください。</li>
          </ul>
        </div>
      </div>
      <div id="cart_main">
        <div id="content">
          <div class="product_list">
            <div v-for="(cart,index) in nowList" :key="'cart-' + index">
              <dd-cartitem
                :cartData="cart"
                :type="'cart'"
                :isOutputCG="isOutputCG"
                @afterCart="afterCart"
                @deleteCartItem="deleteCartItem"
                @updateProductCnt="updateProductCnt"
                @showCameraModal="showCameraModal"
                @onShowEstimateModal="onShowEstimateModal"
              />
            </div>
          </div>
          <template v-if="afterList.length > 0">
            <h2 class="title2">後で買うリスト（{{afterList.length}}点）</h2>
            <div v-for="(cart,index) in afterList" :key="'aftercart-' + index">
              <dd-cartitem
                :cartData="cart"
                :type="'after'"
                @reverseCart="reverseCart"
                @deleteCartItem="deleteCartItem"
                @updateProductCnt="updateProductCnt"
              />
            </div>
          </template>
        </div>
      </div>
      <div class="price_area">
        <div class="cart_price">
          <template v-if="isDispPrice">
            <div class="price_list" v-if="isDispPrice">
              <ul>
                <li>
                  <div>商品・配送 計</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.itemSubTotalPrice)}}</div>
                </li>
                <li>
                  <div>消費税(10%)</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.itemSubTotalTax)}}</div>
                </li>
                <li class="n_separator">
                  <div>商品・配送費小計（税込）</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.itemTotalPrice)}}</div>
                </li>
              </ul>
            </div>
            <div class="price_list construct_price" v-if="isConstruct">
              <ul>
                <li>
                  <div>組立設置他サービス</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.optSubTotalPrice)}}</div>
                </li>
                <li v-if="cartData.cartModel.orderPrice.discntPrice">
                  <div>諸経費割引</div>
                  <div>{{formatPrice(-cartData.cartModel.orderPrice.discntPrice)}}</div>
                </li>
                <li class="n_separator" v-if="cartData.cartModel.orderPrice.discntPrice">
                  <div>小計</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.discntSubTotalPrice)}}</div>
                </li>
                <li>
                  <div>消費税(10%)</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.optTotalTax)}}</div>
                </li>
                <li class="n_separator">
                  <div>組立設置他サービス小計（税込）</div>
                  <div>{{formatPrice(cartData.cartModel.orderPrice.optTotalPrice)}}</div>
                </li>
              </ul>
            </div>
          </template>
          <div class="total_area">
            <div class="total_price">
              <img :src="getImage('common/calculator.svg')" class="icon_calc">
              <div>ご請求額合計</div>
              <div>{{formatPrice(totalPrice)}}</div>
            </div>
            <div class="space"></div>
            <div class="action_area">
              <span :class="{main_btn: true, act_sub_btn: true, disabled: isDifferPostCd || isDifferConstructPostCd || isCarryAll || isDisProduct || !isOneMaker}" @click="estimate()">
                <a>
                  <label>見積りをダウンロード（Excel形式）</label>
                </a>
              </span>
              <span :class="{main_btn: true, sel_main_btn: true, disabled: isDifferPostCd || isDifferConstructPostCd || isCarryAll || isDisProduct || !isOneMaker}" @click="order()">
                <a>
                  <label>注文へ進む</label>
                </a>
              </span>
            </div>
          </div>
          <div class="cart_caition">
            <div class="caution_text_field">
              <div class="caution_title">※ 一度のご注文で同一納品先、かつ同一メーカーの商品をご注文いただけます。</div>
              <div class="caution_text">納品先・組立設置先が異なる商品や、複数メーカーの商品をご注文する場合は「後で買うリスト」機能を活用し、カート内を整理いただいた上でご注文ください。</div>
            </div>
            <div class="caution_text_field" v-if="isHasegawaCp">
              <div class="caution_title">※受け取り搬入サービスをご利用のお客様へ</div>
              <div class="caution_text">サービスをご利用する商品とご利用しない商品を一度に購入する事はできません。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import {mapActions, mapState} from 'vuex'
import * as AppEc from '../utils/AppEc'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import * as FormUtil from '../../utils/FormUtil'
import LoadingModal from '../../components/common/LoadingModal'
import DcCameraPositionModal from '../components/output/DcCameraPositionModal'
import DcFooter from '../components/common/DcFooter'

// Module
import Header from '../components/common/DcHeader'
import CartItem from '../components/common/DcCartItem'

const CART_PRODUCT_MAX_COUNT = 30

export default {
  name: 'Cart',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-cartitem': CartItem,
    'dd-camera-position-modal': DcCameraPositionModal,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      isHasegawaCp: false,
      errorMessage: {},
      validateErrorMessages: {},
      delFlag: false,
      afterFlag: false,
      reverseFlag: false,
      updateFlag: false,
      userInfo: {}
    }
  },
  computed: {
    // ユーザー一覧
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData ||
          !this.cartData.cartModel ||
          !this.cartData.afterModel.orderList ||
          Object.keys(this.cartData.cartModel.orderList).length <= 0) return {}
      return this.cartData.cartModel.orderList
    },
    afterList: function () {
      if (!this.cartData ||
          !this.cartData.afterModel ||
          !this.cartData.afterModel.orderList ||
          Object.keys(this.cartData.afterModel.orderList).length <= 0) return {}
      return this.cartData.afterModel.orderList
    },
    constructList: function () {
      return this.nowList.filter(c => c.planEc.ecInfoOpExFlag === true)
    },
    constructData: function () {
      return this.nowList.find(c => c.planEc.ecInfoOpExFlag === true)
    },
    isCarryIn: function () {
      let carryCnt = this.nowList.filter(c => c.planEc.ecInfoOpCarryFlag === true).length
      return (carryCnt > 0)
    },
    isConstruct: function () {
      return this.nowList.some(c => c.planEc.ecInfoOpExFlag === true)
    },
    isCarryAll: function () {
      let carryCnt = this.nowList.filter(c => c.planEc.ecInfoOpCarryFlag === true).length
      let dataCnt = this.nowList.length
      return (carryCnt !== 0 && carryCnt !== dataCnt)
    },
    isOneMaker: function () {
      if (this.nowList.every(v => v.fileData.originalCorpId === this.nowList[0].fileData.originalCorpId)) {
        return true
      }
      return false
    },
    isDifferPostCd: function () {
      if (!this.nowList || Object.keys(this.nowList).length <= 0) return true
      let postcd = this.nowList[0].planData.planDeliveryPostcd
      let unmatchCnt = this.nowList.filter(c => c.planData.planDeliveryPostcd !== postcd).length
      return (unmatchCnt > 0)
    },
    isDifferConstructPostCd: function () {
      if (!this.constructList || Object.keys(this.constructList).length <= 0) return false
      let postcd = this.constructList[0].planData.planStructPostcd
      let unmatchCnt = this.constructList.filter(c => c.planData.planStructPostcd !== postcd).length
      return (unmatchCnt > 0)
    },
    isWorkFlag: function () {
      let structCnt = this.nowList.filter(d => d.planEc.ecInfoOpExFlag === true).length
      return structCnt > 0
    },
    isHrfManager: function () {
      if (!this.userInfo) return false
      if (this.userInfo.userId === 2869 || this.userInfo.userId === 118 || this.userInfo.userId === 8058) return true
      return false
    },
    pageList: function () {
      let pageList = []
      if (this.isHrfManager) {
        pageList.push({id: 'dcPersonSelect', key: 'dcPersonSelect', title: '店舗担当者選択'})
      }
      if (!this.isAccountPay) {
        pageList.push({id: 'paymentSelect', key: 'paymentSelect', title: '決済方法選択'})
      }
      if (!this.isCarryIn) {
        pageList.push({id: 'order', key: 'orderInput', title: '納品先入力'})
      }
      if (this.isGuestUser) {
        pageList.push({id: 'guest', key: 'guest', title: '発注者情報入力'})
      }
      if (this.isWorkFlag) {
        pageList.push({id: 'struct', key: 'struct', title: '組立設置情報入力'})
      }
      pageList.push({id: 'confirm', key: 'orderConfirm', title: 'ご注文内容確認'})
      if (!this.isAccountPay) {
        pageList.push({id: 'payment', key: 'payment', title: 'お支払い情報入力'})
      }
      pageList.push({id: 'complete', key: 'orderComp', title: '注文完了'})
      return pageList
    },
    isDisProduct: function () {
      if (!this.nowList || Object.keys(this.nowList).length <= 0) return false
      return this.nowList
        .map(c => c.isDisProduct)
        .includes(true)
    },
    isDispPrice: function () {
      if (this.isDifferPostCd || this.isDifferConstructPostCd || this.isCarryAll) {
        return false
      }
      return true
    },
    isGuestUser: function () {
      if (!this.userInfo || this.userInfo.userLevel === 4) {
        return true
      }
      return false
    },
    isAccountPay: function () {
      if (this.userInfo && this.userInfo.isAccountPay) {
        return true
      }
      return false
    },
    totalPrice: function () {
      if (!this.cartData || !this.cartData.cartModel || !this.cartData.cartModel.orderPrice) return 0
      return this.cartData.cartModel.orderPrice.totalPrice
    },
    isSeikyuPlus: function () {
      if (!this.userInfo) return false
      if (this.userInfo.paymentType === 2) return true
      return false
    },
    isOutputCG: function () {
      return (this.userInfo && this.userInfo.menuServiceCode && this.userInfo.menuServiceCode.outputCg)
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    // getCart: function () {
    //   axios.get(DC_URL.CART + '/getinfo')
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //       } else {
    //         this.cartList = response.data.data
    //       }
    //     }).catch(error => {
    //       Api.handleError(error)
    //     }).finally(() => {
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    order: function () {
      if (this.isDifferPostCd) return
      if (this.isDifferConstructPostCd) return
      if (this.isCarryAll) return
      if (!this.nowList || Object.keys(this.nowList).length <= 0) return
      axios.get(DC_URL.CART + '/order')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.orderNext()
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    orderNext: function () {
      App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)
      let commonData = this.nowList[0]
      let orderData = {
        categoryId: commonData.planEc.ecSnapCategoryType,
        infoW: commonData.planEc.ecParamW,
        infoH: commonData.planEc.ecParamH,
        infoD: commonData.planEc.ecParamD,
        infoFillerLeft: commonData.planEc.ecParamFillerLeft,
        infoFillerRight: commonData.planEc.ecParamFillerRight,
        infoFillerCenter: commonData.planEc.ecParamFillerCenter,
        colorDoor: commonData.doorColor,
        colorCabine: commonData.boxColor,
        colorCounter: commonData.centerColor,
        spaceJoincd: commonData.planEc.ecParamSpaceJoincd,
        dcProductCount: commonData.planEc.ecParamProductCount,
        workFlag: this.isWorkFlag,
        pageList: this.pageList,
        isCarryIn: this.isCarryIn,
        corpId: commonData.fileData.originalCorpId
      }
      App.setLocalStorage(DC_STORAGE_KEY.ORDER_DATA, orderData)
      let deliveryData = {
        // businessId: commonData.infoBusinessId,
        businessName: commonData.planData.planDeliveryName,
        building: commonData.planData.planDeliveryBuilding,
        postcd: commonData.planData.planDeliveryPostcd,
        state: commonData.planData.planDeliveryState,
        city: commonData.planData.planDeliveryCity,
        street: commonData.planData.planDeliveryStreet,
        userLastName: commonData.planData.planDeliverryLastName,
        userFirstName: commonData.planData.planDeliverryFirstName,
        userLastNameKana: commonData.planData.planDeliverryLastNameKana,
        userFirstNameKana: commonData.planData.planDeliverryFirstNameKana,
        tel: commonData.planData.planDeliveryTel,
        deliveryDate: this.cartData.cartModel.deliveryDate,
        message: undefined,
        selectTime: 0,
        isRegistAddress: false
      }
      App.setLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA, deliveryData)
      let ldata = this.constructData
      if (ldata && Object.keys(ldata).length > 0) {
        let constructForm = {
          businessName: commonData.planData.planDeliveryName,
          postcd: ldata.planData.planStructPostcd,
          state: ldata.planData.planStructState,
          city: ldata.planData.planStructCity,
          street: ldata.planData.planStructStreet,
          userLastName: ldata.planData.planStructLastName,
          userFirstName: ldata.planData.planStructFirstName,
          userLastNameKana: ldata.planData.planStructLastNameKana,
          userFirstNameKana: ldata.planData.planStructFirstNameKana,
          tel: ldata.planData.planStructTel,
          desiredDate1st: '',
          desiredDate2nd: '',
          desiredDate3rd: '',
          homeType: 1,
          parkingSpace: false,
          message: '',
          isNewInput: false
        }
        App.setLocalStorage(DC_STORAGE_KEY.STRUCT_DATA, constructForm)
      }
      if (this.isHrfManager) {
        this.$router.push({
          name: 'DcPersonSelect'
        })
      } else if (this.isGuestUser) {
        this.$router.push({
          name: 'DcOrderSignIn',
          params: {type: 'order'}
        })
      } else if (this.isCarryIn) {
        this.$router.push({
          name: 'ConstructInput'
        })
      } else if (this.isSeikyuPlus) {
        this.$router.push({
          name: 'DcPaymentSelect'
        })
      } else if (this.isAccountPay) {
        this.$router.push({
          name: 'OrderInput'
        })
      } else {
        this.$router.push({
          name: 'DcPaymentSelect'
        })
      }
    },
    estimate: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'GET',
        url: DC_URL.CART + '/estimate',
        responseType: 'blob'
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
          this.$refs.loadingModalRef.showModal(false)
        } else {
          var pdf = response.data
          let blob = new Blob([pdf], {type: 'application/xlsx;charset=SJIS'})
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, '見積り書.xlsx')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = '見積り書.xlsx'
            link.click()
          }
          this.$refs.loadingModalRef.showModal(false)
        }
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    afterCart: function (odMgCode) {
      if (this.afterFlag) return
      if (this.afterList.length >= CART_PRODUCT_MAX_COUNT) {
        App.showModal({
          messages: ['後で買うリストに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
        })
        return
      }
      this.afterFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode
        }
      }
      axios.get(DC_URL.CART + '/after', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
            this.afterFlag = false
          } else {
            this.$store.dispatch('loadCartData')
              .then(() => {
                this.$refs.loadingModalRef.showModal(false)
                this.afterFlag = false
              })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
          this.afterFlag = false
        }).finally(() => {
        })
    },
    reverseCart: function (odMgCode) {
      if (this.reverseFlag) return
      if (this.nowList.length >= CART_PRODUCT_MAX_COUNT) {
        App.showModal({
          messages: ['カートに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
        })
        return
      }
      this.reverseFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode
        }
      }
      axios.get(DC_URL.CART + '/reverse', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
            this.reverseFlag = false
          } else {
            this.$store.dispatch('loadCartData')
              .then(() => {
                this.$refs.loadingModalRef.showModal(false)
                this.reverseFlag = false
              })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
          this.reverseFlag = false
        }).finally(() => {
        })
    },
    deleteCartItem: function (odMgCode) {
      if (this.delFlag) return
      this.delFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode
        }
      }
      axios.get(DC_URL.CART + '/delete', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
            this.delFlag = false
          } else {
            this.$store.dispatch('loadCartData')
              .then(() => {
                this.$refs.loadingModalRef.showModal(false)
                this.delFlag = false
              })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
          this.delFlag = false
        }).finally(() => {
        })
    },
    updateProductCnt: function (odMgCode, productCount) {
      if (this.updateFlag) return
      this.updateFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          odMgCode: odMgCode,
          productCount: productCount
        }
      }
      axios.get(DC_URL.CART + '/update', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$store.dispatch('loadCartData')
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.updateFlag = false
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    showCameraModal: function (itemData) {
      let modalData = {
        onOk: (callback) => {
          this.$refs.loadingModalRef.showModal(true)
          let payload = {
            params: {
              spaceJoincd: itemData.fileData.spaceJoincd,
              cameraPosition: callback.cameraPosition
            }
          }
          axios.get(DC_URL.CART + '/cg', payload)
            .then(response => {
              if (response.data.errorMessage) {
                this.handleErrorMessage(response)
                this.$refs.loadingModalRef.showModal(false)
              } else {
                App.showModal({
                  messages: ['※出力物はメールで送られます。']
                })
                this.$refs.loadingModalRef.showModal(false)
              }
            }).catch(error => {
              let retError = Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
              App.showModal({
                title: 'システムエラー',
                messages: [retError.errorMessage],
                messageType: 'error',
                textAlign: 'left'
              })
              this.$refs.loadingModalRef.showModal(false)
            })
        }
      }
      AppEc.showCameraPosModal(modalData)
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    },
    onShowEstimateModal: function (estimateData) {
      this.$refs.loadingModalRef.showModal(true)
      // ダイアログ表示
      let modalData = {
        onOk: () => {
          document.body.style.overflow = 'scroll'
        },
        showSuccess: () => {
          this.$refs.loadingModalRef.showModal(false)
          document.body.style.overflow = 'hidden'
        },
        fileName: estimateData.fileName,
        titleDoor: estimateData.titleDoor,
        colorDoor: estimateData.colorDoor,
        titleCabine: estimateData.titleCabine,
        colorCabine: estimateData.colorCabine,
        titleCounter: estimateData.titleCounter,
        colorCounter: estimateData.colorCounter,
        priceData: estimateData.priceData,
        targetPlan: estimateData.targetPlan,
        spaceJoincd: estimateData.spaceJoincd,
        dispOrderButton: false,
        dcProductCount: estimateData.dcProductCount,
        isCalcDelivery: true,
        isDrawing: estimateData.isDrawing,
        makerData: estimateData.makerData,
        isProductData: true,
        isNetPrice: estimateData.isNetPrice
      }
      AppEc.showEstimateModal(modalData)
    },
    formatPrice: function (price) {
      return FormUtil.formatPrice(price)
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }, // method end
  watch: {
  },
  mounted: function () {
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.isHasegawaCp = (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
    this.$store.dispatch('loadCartData', {reload: true})
  }
}
</script>
<style src="../css/dc-cart.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcCart.vue